import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import theme from '../../themes/main';

export const SelectContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 10px 0 20px 0;
  width: 100%;
`;

export const SelectWrapper = styled.div`
  display: block;
  margin: 0;
  max-width: 500px;
  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  border-radius: 4px;
  background: white;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;
  width: 100%;
  z-index: 1;

  ${breakpoint('tablet')`
    width: auto;
  `}

  & > .arrow {
    position: absolute;
    width: 20px;
    height: calc(100% - 15px);
    top: 8px;
    right: 0;
    border-left: 1px solid grey;
    margin-right: 15px;
    z-index: -1;

    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: -7px;
      right: 0;
      margin-top: 16px;
      border-top: 5px solid grey;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
    }
  }
`;

export const Select = styled.select`
  display: block;
  margin: 0;
  max-width: 500px;
  padding: 0 3.5rem 0 14px;
  font-size: 1em;
  border: 0;
  outline: 0;
  border-radius: 4px;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  height: 38px;

  &:focus {
    box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
    -webkit-transition: all 150ms ease;
    transition: all 150ms ease;
  }

  &::-ms-expand {
    display: none;
  }

  ${breakpoint('tablet')`
    width: auto;
  `}
`;

export const ErrorText = styled.span`
  color: ${theme.palette.red};
  font-size: 0.75rem;
  margin-top: 8px;
`;



// WEBPACK FOOTER //
// ./src/components/RyderSelect/styledComponents.js